import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import axios from 'axios'
import * as XLSX from 'xlsx'
import {API_URL} from '../../../tenant/apiBase'

interface ExportButtonProps {
  queryParams: string
  token?: string
  language?: string
}

const ExportButton: React.FC<ExportButtonProps> = ({queryParams, token, language}) => {
  const {formatMessage} = useIntl()
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      const response = await axios.get(
        `${API_URL}/api/partner-portal/product/export-products${queryParams}`,
        {
          headers: {
            token: token || '',
            language: language || 'en',
          },
        }
      )

      // Prepare data for Excel
      const data = response.data.data.map((product: any) => ({
        [formatMessage({id: 'ORDERED_PRODUCTS.BARCODE'})]: product.barcode,
        [formatMessage({id: 'prod_name'})]: product.name,
        [formatMessage({id: 'model_number'})]: product.model || '',
        [formatMessage({id: 'price'})]: product.price,
        [formatMessage({id: 'sale_price'})]: product.special_price || '-',
        [formatMessage({id: 'quantity'})]: product.supplier_quantity,
      }))

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(data)

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Products')

      // Generate Excel file
      XLSX.writeFile(wb, `products-${new Date().toISOString()}.xlsx`)
      
      toast.success(formatMessage({id: 'PRODUCTS.EXPORT_SUCCESS'}))
    } catch (error) {
      console.error('Error exporting products:', error)
      toast.error(formatMessage({id: 'PRODUCTS.EXPORT_ERROR'}))
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <button
      className={`hsb-pl-action hsb-pl-export ${isExporting ? 'is-exporting' : ''}`}
      onClick={handleExport}
      disabled={isExporting}
    >
      {isExporting ? (
        <>
          <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
          {formatMessage({id: 'PRODUCTS.EXPORTING'})}
        </>
      ) : (
        <>
          <i className='fas fa-file-excel' aria-hidden='true'></i>
          {formatMessage({id: 'PRODUCTS.EXPORT_TO_EXCEL'})}
        </>
      )}
    </button>
  )
}

export default ExportButton
